<h1 mat-dialog-title>
    {{title}}
</h1>

<div mat-dialog-content>
    <p [innerHTML]="message"></p>
</div>
<div *ngIf="this.repairJob" class="row">
    <div class="col-sm-12">
        <section id="job_processes_checkboxes" class="example-section">
        <label class="mat-body-strong">Select Processes To Repair:</label>
        <div class="checkbox-group">
            <mat-checkbox
            class="dialog_processes"
            color="primary"
            *ngFor="let process of jobProcesses"
            [checked]="selectedProcesses.includes(process.id)"
            (change)="onProcessCheckboxChange($event, process.id)"
            >
            {{ process.name }}
            </mat-checkbox>
        </div>
        </section>
    </div>
</div>

<div *ngIf="this.showCompanySelection" class="row">
    <div class="col-sm-12">
        <mat-form-field class="MatFormFieldControl">
            <mat-label>Company</mat-label>
            <mat-select #company_selection [(value)]="selectedCompany" required>
                <mat-option *ngFor="let company of allCompanies" [value]="company.id">{{company.company_name}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>

<div class="row" *ngIf="this.hold_or_release">
    <div class="col-sm-12">
        <textarea id="comment_description" placeholder="If yes, specify the reason" rows="2" class="textarea-bg" matInput name="comment_description" [(ngModel)]="comment_description"></textarea>
    </div>
</div>

<div class="row" *ngIf="this.requireRemark">
    <div class="col-sm-12">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ remarkLabel }} <span class="required-asterisk">*</span></mat-label>
            <textarea matInput
                name="status_remark"
                rows="3"
                required
                [placeholder]="remarkPlaceholder"
                [(ngModel)]="statusRemark"></textarea>
            <mat-hint>This remark will be saved against the selected record(s).</mat-hint>
        </mat-form-field>
    </div>
</div>

<div mat-dialog-actions>
    <button mat-button (click)="onDismiss()">No</button>
    <button mat-raised-button color="primary" (click)="onConfirm()">Yes</button>
</div>